import { MutableRefObject } from 'react'

/**
 * collateConfig ensures null|undefined|{} are ignored
 */
export const collateConfig = (a: any, b: any): any => {
    return Object.keys(a ?? {}).length > 0 ? a : b
}

export const buildApiOrderConfig = (sortConfig: any) => {
    return !sortConfig?.order
        ? undefined
        : {
              field: sortConfig.columnKey,
              direction: sortConfig.order === 'ascend' ? 'asc' : 'desc',
          }
}

export const resolveCustomFiltersProp = (filters?: any[], filtersDefaultValue?: any) => {
    const customFilters: any = {}
    filters?.forEach((filter) => {
        customFilters[filter.dataIndex] = filtersDefaultValue?.[filter.dataIndex] ?? null
    })

    return customFilters
}

export const processAutoRefreshProp = (
    refreshProp: boolean | number | (() => boolean | number),
    refreshRef: MutableRefObject<any>,
    refreshCb: () => void,
) => {
    const resolvedAutoRefreshValue = typeof refreshProp === 'function' ? refreshProp() : refreshProp
    const autoRefreshMs =
        typeof resolvedAutoRefreshValue === 'number' ? resolvedAutoRefreshValue : !resolvedAutoRefreshValue ? 0 : 5_000

    if (autoRefreshMs > 0) {
        refreshRef.current = setTimeout(() => refreshCb(), autoRefreshMs)
    }
}
